module.exports = __webpack_public_path__ + "static/img/3.2b135fa6.jpg";